import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getUserInfoMap, getChannelMap } from "@/utils/dictionary";
export default {
  name: "showNoticeMsg",
  props: {
    infoMsg: Object
  },
  data: function data() {
    return {
      type: {
        1: "登录公告"
      },
      pop: {
        0: "不弹出",
        1: "弹出"
      },
      status: {
        0: "关闭",
        1: "开启"
      },
      UserMap: {},
      channelMap: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getChannelMap();
            case 2:
              _this.channelMap = _context.sent;
              _context.next = 5;
              return getUserInfoMap();
            case 5:
              _this.UserMap = _context.sent;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};